import React from 'react';
import ReactDOM from 'react-dom';
import Widget from './components/widget';
import { Router, Route, hashHistory } from 'react-router';

// Query DOM for all widget wrapper divs
let whereToRender = document.querySelectorAll( 'div.mp-plus-events-calendar' ),
	widgets = Array.prototype.slice.call( whereToRender );

// Iterate over the DOM nodes and render a React component into each node
widgets.forEach((wrapper) =>{
	ReactDOM.render(
		<Router history={hashHistory}>			
			<Route path="/" component={Widget}>
				<Route path="/ville/:ville" component={Widget}/>
				<Route path="/formation/:formation" component={Widget}/>
			</Route>
			<Route path="*" component={Widget}/>
		</Router>, wrapper);
});



/** WEBPACK FOOTER **
 ** ./src/widget.js
 **/